export const BASE_APP_NAV_VERSION = "1.0.0";
export const BASE_VW_APP_NAV_VERSION = "1.0.0";
export const BASE_VWA_APP_NAV_VERSION = "0.0.0";
export const BASE_LEXUS_APP_NAV_VERSION = "0.0.0";
export const SVW_SDK_APP_NAV_VERSION = "0.0.0";
export const SVW_APP_NAV_VERSION = "0.0.0";
export const PATON_APP_NAV_VERSION = "0.0.0";
export const CHENGQU_APP_NAV_VERSION = "0.0.0";
export const CHENGQU_HARMONY_NAV_VERSION = "4.3.0";
export const TIKA_APP_NAV_VERSION = "0.0.0";
export const RHINOS_APP_NAV_VERSION = "0.0.0";
export const DPCA_APP_NAV_VERSION = "0.0.0";
export const DPCA_PEUGEO_APP_NAV_VERSION = "0.0.0";
export const VWSDK_HARMONY_NAV_VERSION = "2.0.0";
export const DPCA_HARMONY_NAV_VERSION = "2.0.0";
export const DPCA_PEUGEO_HARMONY_NAV_VERSION = "2.0.0";

let baseURL = "",
  webviewEnv = "";
switch (true) {
  case location.href.includes("//sit-hybrid."):
    baseURL = "https://sit-xplan.ingeek.com/api";
    webviewEnv = "develop";
    break;
  case location.href.includes("uat-hybrid."):
    baseURL = "https://uat-xplan.ingeek.com/api";
    webviewEnv = "trial";
    break;
  case location.href.includes("//pre-hybrid."):
    baseURL = "https://pre-appserver.ingeek.com/api";
    webviewEnv = "pre-release";
    break;
  case location.href.includes("//hybrid.nokeeu.com"):
    baseURL = "https://appserver.nokeeu.com/api";
    webviewEnv = "release";
    break;
  case location.href.includes("//hybrid2.nokeeu.com"):
    baseURL = "https://appserver2.nokeeu.com/api";
    webviewEnv = "release";
    break;
  case location.href.includes("//uat-hybrid-sg."):
    baseURL = "https://uat-xplan-sg.ingeek.com/api";
    webviewEnv = "trial";
    break;
  case location.href.includes("hybrid.tikakey.com"):
    baseURL = "https://api.tikakey.com/api";
    webviewEnv = "release";
    break;
  case location.href.includes("hybrid.rhinoskey.com"):
    baseURL = "https://api.rhinoskey.com/api";
    webviewEnv = "release";
    break;
  default:
    baseURL = "https://uat-xplan.ingeek.com/api";
    // baseURL = "https://uat-xplan.ingeek.com/api";
    // baseURL = "https://appserver.nokeeu.com/api";
    // baseURL = "https://appserver.nokeeu.com/api";
    webviewEnv = "trial";
    break;
}
console.info(`🔗🔗🔗🔗: ${baseURL}`);
function parseUserAgent(ua: string) {
  const result = {
    browser: "Unknown",
    version: "Unknown",
    clientType: "Unknown", // 'Mobile' or 'PC'
  };

  // 判断客户端类型
  if (/Mobile|Android|iPhone|iPad|iPod|IEMobile|Windows Phone/i.test(ua)) {
    result.clientType = "Mobile";
  } else {
    result.clientType = "PC";
  }

  // 匹配常见浏览器及其版本
  const browserRegexes = [
    { name: "Edge", regex: /Edg\/([\d.]+)/ },
    { name: "Chrome", regex: /Chrome\/([\d.]+)/ },
    { name: "Firefox", regex: /Firefox\/([\d.]+)/ },
    { name: "Safari", regex: /Version\/([\d.]+).*Safari/ },
    { name: "Opera", regex: /OPR\/([\d.]+)/ },
    { name: "IE", regex: /MSIE ([\d.]+)|Trident\/.*rv:([\d.]+)/ },
  ];

  for (const { name, regex } of browserRegexes) {
    const match = ua.match(regex);
    if (match) {
      result.browser = name;
      result.version = match[1] || match[2]; // 针对IE的两种情况
      break;
    }
  }

  return result;
}

// 示例用法
const appConfigs = [
  { name: "Nokey", baseVersion: BASE_APP_NAV_VERSION },
  { name: "VWA", baseVersion: BASE_VWA_APP_NAV_VERSION },
  { name: "LexusSDK", baseVersion: BASE_LEXUS_APP_NAV_VERSION },
  { name: "VWSDK", baseVersion: SVW_SDK_APP_NAV_VERSION },
  { name: "SVW", baseVersion: SVW_APP_NAV_VERSION },
  { name: "Paton", baseVersion: PATON_APP_NAV_VERSION },
  { name: "ChengQu", baseVersion: CHENGQU_APP_NAV_VERSION },
  { name: "Tika", baseVersion: TIKA_APP_NAV_VERSION },
  { name: "Rhinos", baseVersion: RHINOS_APP_NAV_VERSION },
  { name: "DpcaPeugeo", baseVersion: DPCA_PEUGEO_APP_NAV_VERSION },
  { name: "Dpca", baseVersion: DPCA_APP_NAV_VERSION },
];

const userAgent = navigator.userAgent;
const webviewBrower = parseUserAgent(userAgent);
const matchedApp = appConfigs.find(({ name }) => userAgent.includes(name));
const regexType = matchedApp
  ? new RegExp(`${matchedApp.name}[\\s/]\\d{1}\\.\\d{1,2}\\.\\d{1,2}`, "i")
  : null;
const uaMatch = regexType ? userAgent.match(regexType)?.[0] : null;
const uaResult = uaMatch ? uaMatch.split(/[/ ]/) : [];
const isAppWebView =
  userAgent.includes("VWA") ||
  userAgent.includes("Paton") ||
  userAgent.includes("SVW") ||
  userAgent.includes("VWSDK") ||
  userAgent.includes("LexusSDK") ||
  userAgent.includes("Nokey") ||
  userAgent.includes("ChengQu") ||
  userAgent.includes("Tika") ||
  userAgent.includes("Rhinos") || userAgent.includes("Dpca");
export function getEnv() {
  const sdkType = matchedApp?.name ?? "";
  const version = uaResult?.[1] || "0.0.0";
  const isIOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent);
  const isQq = /\sqq/i.test(userAgent);
  const isOpenHarmony = /OpenHarmony/i.test(userAgent);
  const isWx =
    /Weixin/gi.test(userAgent) ||
    /wechatdevtools/.test(userAgent) ||
    /MicroMessenger/.test(userAgent);
  const isAndroid = /android|adr/i.test(userAgent);
  const isMiniProgram = /miniprogram|miniProgram/i.test(userAgent);

  return {
    isAppWebView: isAppWebView,
    versionNum: version,
    appName: sdkType,
    isVWA: userAgent.includes("VWA"),
    isPaton: userAgent.includes("Paton"),
    isLexus: userAgent.includes("Lexus"),
    isSVW: userAgent.includes("SVW"),
    isSVWSDK: userAgent.includes("VWSDK"),
    isNokey: userAgent.includes("Nokey"),
    isTika: userAgent.includes("Tika"),
    isRhinos: userAgent.includes("Rhinos"),
    isDpca: userAgent.includes("Dpca"),
    isDpcaPeugeo: userAgent.includes("DpcaPeugeo"),
    canUseWebRouter: compareVersion(
      version,
      matchedApp?.baseVersion ?? "0.0.1"
    ),
    isChengQu: userAgent.includes("ChengQu"),
    isIOS,
    isWx,
    isQq,
    isOpenHarmony,
    isAndroid,
    isMiniProgram,
    baseURL: baseURL,
    webviewEnv: webviewEnv,
    appType: isIOS ? "IOS" : "ANDROID",
    browser: webviewBrower.browser,
    version: webviewBrower.version,
    clientType: webviewBrower.clientType,
    UA: userAgent,
  };
}

export function compareVersion(ver1: string, ver2: string): boolean {
  if (!ver1 || !ver2) return false;
  const verOneArr = ver1.split(".").map(Number);
  const verTwoArr = ver2.split(".").map(Number);
  const maxLen = Math.max(verOneArr.length, verTwoArr.length);

  for (let i = 0; i < maxLen; i++) {
    const a = verOneArr[i] || 0;
    const b = verTwoArr[i] || 0;
    if (a > b) return true;
    if (a < b) return false;
  }
  return true;
}
export default getEnv();
